<template>
  <el-col class="station-block">
    <el-row class="station-main">
      <el-row style="color: #fff;text-align: left;font-size: 14px;">站点数</el-row>
      <el-row class="show-area" :style="getPadding(1)">
        <el-col class="station-txt" :style="getPadding(0)">{{ siteNum }}座</el-col>
      </el-row>
    </el-row>
  </el-col>
</template>

<script>
export default {
  name: "StationBlock",
  props: ["isFull", "siteNum"],
  methods: {
    getPadding(sIndex) {
      if(sIndex === 0) return this.isFull ? 'padding: 10px;font-size: 48px;' : 'padding: 16px;font-size: 36px;'
      if(sIndex === 1) return this.isFull ? 'margin-top:36px;' : 'margin-top: 22px;'
    }
  }
}
</script>

<style scoped>
  .station-block{
    height: 100%;
    width: 203px;
  }
  .station-main{
    height: 100%;
    width: 100%;
    padding: 24px 24px 0 24px;
    background: url("../../../assets/images/digital-screen/site_bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .show-area{
    width: 100%;
    padding: 1px;
    height: 100%;
  }
  .station-txt{
    width: 100%;
    height: 100%;
    align-items: center;
    font-size: 48px;
    font-weight: bold;
    color: #FCB268;
    letter-spacing: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/DigitalScreen/StationBlock.vue